import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'rootReducer';
import { StatField, StatsSliceState } from './statsSliceTypes';
import { MatchStatisticType } from '../../enums/matchStatisticType';

const initStatField = (name, matchStatisticsTypeId) => ({
  auto: false,
  name,
  matchStatisticsTypeId,
});

const initialState: StatsSliceState = {
  fields: {
    shotsOnGoal: initStatField('shotsOnGoal', MatchStatisticType.SHOTS_ON_TARGET),
    postHits: initStatField('postHits', MatchStatisticType.POST_HITS),
    shotsOffTarget: initStatField('totalShots', MatchStatisticType.TOTAL_SHOTS),
    chances: initStatField('chances', MatchStatisticType.CHANCES),
    saves: initStatField('yellowCards', MatchStatisticType.SAVES),
  },
};

export const statsSlice = createSlice({
  name: 'stats',
  initialState,
  reducers: {
    toggleAutoOnField(state, action) {
      const fieldName = action.payload;
      const value = state.fields[fieldName].auto;

      state.fields[fieldName].auto = !value;
    },
    setChoose(state, action) {
      const fieldName = action.payload.name;
      state.fields[fieldName].choose = action.payload.teamOption;
    },
    removeChoose(state, action) {
      const fieldName = action.payload;
      state.fields[fieldName].choose = undefined;
    },
  },
});

export const statsSliceActions = statsSlice.actions;

export const selectFields = (state: RootState) => {
  return state.stats.fields;
};

export const selectChoose = createSelector(selectFields, (fields) => {
  return { shotsOffTarget: fields.shotsOffTarget.choose, postHits: fields.postHits.choose };
});

export const selectShotsOnGoalField = createSelector(selectFields, (fields): StatField => {
  return {
    auto: fields.shotsOnGoal.auto,
    name: fields.shotsOnGoal.name,
    matchStatisticsTypeId: MatchStatisticType.SHOTS_ON_TARGET,
  };
});

export const selectPostHitsField = createSelector(selectFields, (fields): StatField => {
  return {
    auto: fields.postHits.auto,
    name: fields.postHits.name,
    matchStatisticsTypeId: MatchStatisticType.POST_HITS,
  };
});

export const selectChancesField = createSelector(selectFields, (fields): StatField => {
  return {
    auto: fields.chances.auto,
    name: fields.chances.name,
    matchStatisticsTypeId: MatchStatisticType.CHANCES,
  };
});

export const selectSavesField = createSelector(selectFields, (fields): StatField => {
  return {
    auto: fields.saves.auto,
    name: fields.saves.name,
    matchStatisticsTypeId: MatchStatisticType.SAVES,
  };
});

export const selectShotsOffTargetField = createSelector(selectFields, (fields): StatField => {
  return {
    auto: fields.shotsOffTarget.auto,
    name: fields.shotsOffTarget.name,
    matchStatisticsTypeId: MatchStatisticType.TOTAL_SHOTS,
  };
});

export default statsSlice.reducer;
